module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "integralMallOrder zdy-groupList commonStyle"
  }, [_c('x-header', {
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_vm._v("支付结果")]), _vm._v(" "), _c('msg', {
    staticStyle: {
      "margin-top": "46px"
    },
    attrs: {
      "title": "支付成功！",
      "buttons": _vm.buttons,
      "icon": "success"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-679517f0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/integralMallProject/integralMallOrderResult.vue
// module id = 5Rvz
// module chunks = 7